import { boxShadows, corners, marginBottom, marginRight, media, padding, paddingTop, typography } from "../../../../common/styles";
import { AppContext, Organisation } from "../../../../AppDataProvider/AppDataProvider";
import React, { ReactElement, useContext } from "react";
import { applyOpacity } from "../../../../common/styles/utils";
import { Button } from "../../../../common/components";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import styled from "styled-components";
import { UnitOfMeasurement } from "../../../../GeneratedGraphQL";
import { useTranslation } from "react-i18next";
export type OnSelectOrganisationOpts = {
  organisation: Organisation;
};
type MarkerProps = {
  map?: mapkit.Map;
  onClosePopup: () => void;
  onSelectOrganisation: (options: OnSelectOrganisationOpts) => void;
  organisation: Organisation;
  organisationCount: number;
};
export function Marker(props: MarkerProps): ReactElement {
  const {
    t
  } = useTranslation();
  const {
    appData
  } = useContext(AppContext);
  const {
    organisation,
    organisationCount,
    onSelectOrganisation,
    onClosePopup,
    map
  } = props;
  const displayOrganisation = (organisation as Organisation & {
    proximityToSearchedLocation: number;
  });
  const proximityToSearchedLocation = displayOrganisation.proximityToSearchedLocation;
  const address = displayOrganisation.location?.address;
  const d = document.getElementById("markerContainerId");
  if (d && map && map.element) {
    const pos = map.element.getBoundingClientRect();
    d.style.position = "absolute";
    d.style.left = (pos.x + pos.width / 2 - d.offsetWidth / 2).toString() + "px";
    d.style.top = (pos.y + pos.height / 2).toString() + "px";
  }
  return <MarkerContainer id="markerContainerId" data-testid="marker-container" data-sentry-element="MarkerContainer" data-sentry-component="Marker" data-sentry-source-file="Marker.tsx">
      <TopSection data-sentry-element="TopSection" data-sentry-source-file="Marker.tsx">
        <OrganisationContent data-sentry-element="OrganisationContent" data-sentry-source-file="Marker.tsx">
          <Name data-sentry-element="Name" data-sentry-source-file="Marker.tsx">{`${organisationCount}. ${displayOrganisation.name}`}</Name>
          {address && <>
              <Location>{address}</Location>
              {proximityToSearchedLocation && <Distance>
                  <Label>{t("distance")}</Label>
                  <Value>
                    {`${proximityToSearchedLocation >= 10 ? proximityToSearchedLocation.toFixed(0) : proximityToSearchedLocation.toFixed(1)} ${appData.bookingTool.unitOfMeasurement === UnitOfMeasurement.Miles ? t("miles") : t("kilometres")}`}
                  </Value>
                </Distance>}
            </>}
        </OrganisationContent>
        <CloseButton aria-label={t("closeOrganisationPopup")} onClick={() => {
        onClosePopup();
      }} data-sentry-element="CloseButton" data-sentry-source-file="Marker.tsx">
          <CloseIcon data-sentry-element="CloseIcon" data-sentry-source-file="Marker.tsx" />
        </CloseButton>
      </TopSection>

      <Button variant="primary" onClick={() => onSelectOrganisation({
      organisation
    })} data-sentry-element="Button" data-sentry-source-file="Marker.tsx">
        {t("select")}
      </Button>
    </MarkerContainer>;
}
export default Marker;
const MarkerContainer = styled.div`
  display: flex;
  flex-direction: column;
  background: white;
  width: 300px;

  position: fixed;
  z-index: 2;

  @media ${media.desktop} {
    left: 55%;
    top: 40%;
  }

  ${corners.l}
  ${padding.m}
  ${paddingTop.xs}
  ${boxShadows.subtleShadow}
`;
const TopSection = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding-bottom: 12px;
`;
const OrganisationContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;
const Name = styled.h2`
  ${typography.subtitle}
  ${marginBottom.m}
`;
const Location = styled.div`
  ${marginBottom.xs}
  ${typography.body}
`;
const Distance = styled.div`
  display: flex;
  flex-direction: row;
`;
const Label = styled.span`
  ${typography.small}
  color: ${({
  theme
}) => applyOpacity(theme.colours.dark, 0.6)};
  ${marginRight.s}
`;
const Value = styled.span`
  ${typography.small}
`;
const CloseButton = styled.button`
  border: none;
  background: none;
  ${paddingTop.m}
  align-items: end;
  height: 1.25rem;
  width: 1.25rem;

  @media ${media.hoverable} {
    &:hover {
      cursor: pointer;
    }
  }
`;
const CloseIcon = styled(FontAwesomeIcon).attrs({
  icon: faTimes
})`
  color: ${({
  theme
}) => applyOpacity(theme.colours.dark, 0.8)};
  font-size: 1rem;
`;